import { symbolFor } from "./currency";

// The ONE price format for every product card: the listing/search/craft grids, search
// autocomplete, PDP "you may also like", Newly Arrived, offer tiles, wishlist, best sellers and
// most searched. The same product must never read differently on two screens.
//
//   whole amount  -> no decimals    "₹1,140"
//   has paise     -> exactly two    "₹2,113.75", "₹3,277.50" (plain toLocaleString gives "₹3,277.5")
//
// Prices are NOT rounded to rupees: a store discount produces paise, and that is what checkout
// charges. Cart, PDP and order totals keep HelperFunctions.formatAmount (always two decimals).
// Indian grouping for ₹, US for $ (amounts arrive already converted; we only add the symbol).

export const formatCardAmount = (n, symbol = "₹") => {
  if (n == null || n === "" || isNaN(Number(n))) return "";
  const value = Math.round(Number(n) * 100) / 100;
  const hasPaise = value % 1 !== 0;
  return (
    symbol +
    value.toLocaleString(symbol === "$" ? "en-US" : "en-IN", {
      minimumFractionDigits: hasPaise ? 2 : 0,
      maximumFractionDigits: 2,
    })
  );
};

// Same, from a currency CODE ("INR"/"USD") as the listing payloads carry it.
export const formatCardPrice = (n, currency = "INR") =>
  formatCardAmount(n, symbolFor(currency));
